import { apiRoutes } from "@constants/api-routes";
import { handleRequest } from "@utils/http-util";
import { RequestTypes } from "@enums/request-types";
import { AxnAttributeLabel } from "@idw-types/data/reference-data/axn";

type GetAxnAttributeLabelRequestResponse = {
    axnAttributeLabels: Array<AxnAttributeLabel>;
};

export const getAxnAttributeLabelsRequest = async (): Promise<{ data: GetAxnAttributeLabelRequestResponse, error: any }> => {
    const route = apiRoutes.axnadminCore.data.axnattributelabel;

    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};